import { validateStrEnumValue } from '@mobalytics/shared';
import { GQLAPIErrorMessage } from '../types/error.types';
import { AccountsSignUpError } from '../__generated/accountsV2/types';
import { AccountsSignInError } from '../__generated/treasury/types';

export const normalizeError = (error: string) => {
  throw validateStrEnumValue<GQLAPIErrorMessage>(GQLAPIErrorMessage, error) || GQLAPIErrorMessage.INTERNAL_ERROR;
};

export const ACCOUNTS_V2_ERROR_CODE_MAP: Record<string, GQLAPIErrorMessage> = {
  USER_ALREADY_EXISTS: GQLAPIErrorMessage.AUTH_EMAIL_ALREADY_EXISTS,
  INVALID_EMAIL: GQLAPIErrorMessage.EMAIL_INVALID,
  INVALID_PASSWORD: GQLAPIErrorMessage.PASSWORD_INVALID,
  INVALID_CREDENTIALS: GQLAPIErrorMessage.AUTH_CREDENTIALS_INVALID,
  EMPTY_INPUT: GQLAPIErrorMessage.INTERNAL_ERROR,
  INTERNAL_ERROR: GQLAPIErrorMessage.INTERNAL_ERROR,
  UNAUTHORIZED: GQLAPIErrorMessage.UNAUTHENTICATED,
};

export const mapAccountsV2SignUpErrorCode = (
  code: AccountsSignUpError | null | undefined
): GQLAPIErrorMessage | null => {
  if (!code) return null;
  return ACCOUNTS_V2_ERROR_CODE_MAP[code] ?? GQLAPIErrorMessage.INTERNAL_ERROR;
};

export const mapAccountsV2SignInErrorCode = (
  code: AccountsSignInError | null | undefined
): GQLAPIErrorMessage | null => {
  if (!code) return null;
  return ACCOUNTS_V2_ERROR_CODE_MAP[code] ?? GQLAPIErrorMessage.INTERNAL_ERROR;
};
